var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChromeStore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 47,
    viewBox: "0 0 130 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130 41.8562C130 44.3873 128.326 46.4375 126.256 46.4375H3.7484C1.67941 46.4375 0 44.3873 0 41.8562V5.32167C0 2.79178 1.67941 0.734375 3.7484 0.734375H126.256C128.326 0.734375 129.999 2.79178 129.999 5.32167L130 41.8562Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6375 34.2061C57.2717 34.2061 59.0649 32.8175 59.5013 30.453H57.7319C57.3749 31.8336 56.2402 32.6509 54.6454 32.6509C52.5427 32.6509 51.2097 30.9608 51.2097 28.2869C51.2097 25.6367 52.5586 23.9308 54.6375 23.9308C56.1926 23.9308 57.4146 24.8909 57.7319 26.3588H59.4934C59.1919 23.9705 57.2321 22.3756 54.6375 22.3756C51.4398 22.3756 49.3927 24.6608 49.3927 28.2869C49.3927 31.9368 51.424 34.2061 54.6375 34.2061ZM61.001 34.0156H62.7228V29.0803C62.7228 27.6997 63.5321 26.7793 64.873 26.7793C66.1346 26.7793 66.7773 27.5569 66.7773 28.8423V34.0156H68.4991V28.509C68.4991 26.5651 67.3645 25.3035 65.4681 25.3035C64.151 25.3035 63.2623 25.8351 62.7466 26.8507H62.7069V22.0503H61.001V34.0156ZM70.2289 34.0156H71.9507V28.874C71.9507 27.66 72.6648 26.8745 73.7994 26.8745C74.1406 26.8745 74.4421 26.9221 74.585 26.9777V25.3669C74.4501 25.3352 74.2358 25.3114 73.9819 25.3114C72.9663 25.3114 72.1729 25.8906 71.9031 26.8507H71.8713V25.3987H70.2289V34.0156ZM79.0125 34.1188C81.5039 34.1188 83.0829 32.4208 83.0829 29.7072C83.0829 26.9935 81.496 25.2876 79.0125 25.2876C76.5289 25.2876 74.9341 27.0015 74.9341 29.7072C74.9341 32.4208 76.521 34.1188 79.0125 34.1188ZM79.0125 32.6906C77.5525 32.6906 76.6797 31.5876 76.6797 29.7072C76.6797 27.8346 77.5525 26.7158 79.0125 26.7158C80.4724 26.7158 81.3373 27.8267 81.3373 29.7072C81.3373 31.5876 80.4724 32.6906 79.0125 32.6906ZM84.4635 34.0156H86.1853V28.7312C86.1853 27.6045 86.947 26.7793 88.0103 26.7793C89.0179 26.7793 89.6606 27.4141 89.6606 28.4138V34.0156H91.3507V28.6677C91.3507 27.5648 92.0966 26.7793 93.1519 26.7793C94.223 26.7793 94.834 27.4299 94.834 28.5566V34.0156H96.5479V28.144C96.5479 26.4222 95.437 25.3035 93.739 25.3035C92.5092 25.3035 91.4935 25.9382 91.0413 26.9777H91.0016C90.6525 25.9065 89.7876 25.3035 88.5895 25.3035C87.4628 25.3035 86.5344 25.8906 86.1377 26.8586H86.106V25.3987H84.4635V34.0156ZM101.856 26.692C103.11 26.692 103.959 27.5807 103.998 28.9216H99.6265C99.7217 27.5966 100.618 26.692 101.856 26.692ZM103.99 31.4924C103.752 32.2462 102.967 32.7223 101.967 32.7223C100.555 32.7223 99.6185 31.7384 99.6185 30.2467V30.1436H105.72V29.5405C105.72 26.9301 104.229 25.2876 101.864 25.2876C99.4519 25.2876 97.8809 27.0411 97.8809 29.7389C97.8809 32.4366 99.436 34.1188 101.935 34.1188C103.871 34.1188 105.387 33.0397 105.633 31.4924H103.99Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9905 16.2308V15.5435H52.323V16.4435H53.8341L53.8286 16.5417C53.8068 17.3764 53.1522 17.9437 52.203 17.9437C51.0738 17.9437 50.3647 17.0872 50.3647 15.6853C50.3647 14.3052 51.0411 13.4924 52.1758 13.4924C52.9449 13.4924 53.5231 13.9015 53.7413 14.5943H54.936C54.7287 13.3342 53.6322 12.4832 52.1703 12.4832C50.3156 12.4832 49.1591 13.6997 49.1591 15.6962C49.1591 17.72 50.3156 18.9474 52.1921 18.9474C53.9486 18.9474 54.9905 17.9273 54.9905 16.2308ZM60.1892 17.84H57.2216V16.1435H60.031V15.2053H57.2216V13.596H60.1892V12.5923H56.0379V18.8438H60.1892V17.84ZM64.0677 18.8438V13.596H65.9933V12.5923H60.9638V13.596H62.8894V18.8438H64.0677ZM70.6519 18.8438V16.329H73.3139V15.3689H70.6519V13.596H73.5649V12.5923H69.4682V18.8438H70.6519ZM77.3507 12.4832C75.4741 12.4832 74.3068 13.7269 74.3068 15.718C74.3068 17.7091 75.4741 18.9474 77.3507 18.9474C79.2163 18.9474 80.3891 17.7091 80.3891 15.718C80.3891 13.7269 79.2163 12.4832 77.3507 12.4832ZM77.3507 13.5033C78.4689 13.5033 79.1781 14.3597 79.1781 15.718C79.1781 17.0763 78.4689 17.9328 77.3507 17.9328C76.2215 17.9328 75.5123 17.0763 75.5123 15.718C75.5123 14.3597 76.2269 13.5033 77.3507 13.5033ZM82.5984 13.5469H83.8639C84.5731 13.5469 85.015 13.9506 85.015 14.5834C85.015 15.238 84.6004 15.6198 83.8858 15.6198H82.5984V13.5469ZM82.5984 16.5199H83.8258L85.064 18.8438H86.4169L85.0313 16.3344C85.7896 16.0617 86.226 15.3744 86.226 14.5561C86.226 13.3451 85.3968 12.5923 83.9949 12.5923H81.4146V18.8438H82.5984V16.5199Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.042 37.1344C33.5583 37.1344 39.6514 31.0789 39.6514 23.609C39.6514 16.1391 33.5583 10.0835 26.042 10.0835C18.5257 10.0835 12.4326 16.1391 12.4326 23.609C12.4326 31.0789 18.5257 37.1344 26.042 37.1344Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7023 26.0677C34.7023 21.314 30.8249 17.4604 26.0419 17.4604C21.2588 17.4604 17.3813 21.314 17.3813 26.0677H19.8557C19.8557 22.6721 22.6253 19.9196 26.0417 19.9196C29.4582 19.9196 32.2278 22.6721 32.2278 26.0677",
    fill: "black",
    fillOpacity: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6605 30.0022C29.257 30.0022 31.362 27.9102 31.362 25.3297C31.362 22.7492 29.257 20.6572 26.6605 20.6572C24.064 20.6572 21.959 22.7492 21.959 25.3297C21.959 27.9102 24.064 30.0022 26.6605 30.0022Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0419 28.6499C28.8434 28.6499 31.1145 26.3928 31.1145 23.6086C31.1145 20.8244 28.8434 18.5674 26.0419 18.5674C23.2405 18.5674 20.9694 20.8244 20.9694 23.6086C20.9694 26.3928 23.2405 28.6499 26.0419 28.6499Z",
    fill: "url(#paint0_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4139 17.4604C35.0077 10.6497 26.6911 7.8726 19.8379 11.2576C17.7011 12.313 15.8747 13.899 14.5358 15.862L20.1033 25.4529C19.0781 22.2141 20.8888 18.7622 24.1477 17.7432C24.7209 17.5641 25.3173 17.4688 25.9181 17.4604",
    fill: "url(#paint1_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5358 15.8623C10.2746 22.18 11.9732 30.7343 18.3298 34.9695C20.2965 36.2799 22.5683 37.0675 24.9283 37.2573L30.7435 27.4207C28.569 30.04 24.6704 30.4112 22.0351 28.2504C21.14 27.5166 20.4706 26.5474 20.1033 25.4535",
    fill: "url(#paint2_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9285 37.2568C32.5595 37.8301 39.2134 32.1468 39.7906 24.5628C39.9768 22.1158 39.5015 19.6637 38.4139 17.4604H25.9183C29.3344 17.4761 32.0915 20.2412 32.0757 23.6368C32.0693 25.0105 31.6002 26.3424 30.7433 27.4203",
    fill: "url(#paint3_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5358 15.8616L20.1033 25.4525C19.6909 24.0731 19.7784 22.5937 20.3506 21.2718L14.7831 15.4927",
    fill: "url(#paint4_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9284 37.2574L30.7435 27.4209C29.826 28.5082 28.5583 29.2466 27.1555 29.5111L24.6809 37.2574",
    fill: "url(#paint5_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4139 17.4604H25.918C26.8472 17.4647 27.7635 17.677 28.5988 18.0815C29.4341 18.4859 30.167 19.0722 30.7431 19.7968L38.6612 17.8296",
    fill: "url(#paint6_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 26.0359,
    y1: 18.5819,
    x2: 26.0359,
    y2: 28.6531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81B4E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C5A94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 26.4748,
    y1: 9.8369,
    x2: 26.4748,
    y2: 21.0264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F06B59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF2227"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 15.5589,
    y1: 33.3972,
    x2: 21.1986,
    y2: 24.0217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#388B41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4CB749"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 34.624,
    y1: 34.391,
    x2: 28.6254,
    y2: 19.8557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4B022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FCD209"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 17.4431,
    y1: 25.0836,
    x2: 17.4431,
    y2: 15.247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.03
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 31.1049,
    y1: 28.2609,
    x2: 24.3433,
    y2: 35.1882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.03
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 31.006,
    y1: 30.2414,
    x2: 31.9837,
    y2: 20.527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.03
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChromeStore);
export default __webpack_public_path__ + "static/media/chrome-store.c75a94e6d8d81e7af8e0f6438fd4fbfc.svg";
export { ForwardRef as ReactComponent };